export const mockSixSteps = [
  {
    key: "reward",
    name: "Reward and Recognition",
    score: 100
  },
  {
    key: "information",
    name: "Information Sharing",
    score: 100
  },
  {
    key: "empowerment",
    name: "Empowerment",
    score: 100
  },
  {
    key: "wellBeing",
    name: "Well-being",
    score: 100
  },
  {
    key: "pride",
    name: "Instilling Pride",
    score: 100
  },
  {
    key: "jobSatisfaction",
    name: "Job Satisfaction",
    score: 100
  }
]

export const mockIndicators = {
  wellBeingRisk: {
    industry: 100,
    global: 100,
    total: 1,
    count: 0,
    average: {
      score: 100,
      global: 100,
      industry: 100
    }
  },
  managementConfidence: {
    average: {
      score: 100,
      industry: 100,
      global: 100
    }
  },
  flightRisk: {
    industry: 100,
    total: 1,
    count: 0,
    global: 100,
    average: {
      score: 100,
      global: 100,
      industry: 100
    }
  }
}

export const mockDiversityAndInclusion = [
  {
    name: "Gender",
    scores: [
      {
        label: "Male",
        values: {
          score: 100,
          industry: 100,
          global: 100
        }
      },
      {
        label: "Female",
        values: {
          score: 100,
          industry: 100,
          global: 100
        }
      },
      {
        label: "Prefer not to say",
        values: {
          score: 100,
          industry: 100,
          global: 100
        }
      },
      {
        label: "other",
        values: {
          score: 100,
          industry: 100,
          global: 100
        }
      }
    ]
  },
  {
    name: "Age",
    scores: [
      {
        label: "16-18",
        values: {
          score: 100,
          industry: 100,
          global: 100
        }
      },
      {
        label: "19-24",
        values: {
          score: 100,
          industry: 100,
          global: 100
        }
      },
      {
        label: "25-34",
        values: {
          score: 100,
          industry: 100,
          global: 100
        }
      },
      {
        label: "35-44",
        values: {
          score: 100,
          industry: 100,
          global: 100
        }
      },
      {
        label: "45-54",
        values: {
          score: 100,
          industry: 100,
          global: 100
        }
      },
      {
        label: "55-64",
        values: {
          score: 100,
          industry: 100,
          global: 100
        }
      },
      {
        label: "65+",
        values: {
          score: 100,
          industry: 100,
          global: 100
        }
      },
      {
        label: "Prefer not to say",
        values: {
          score: 100,
          industry: 100,
          global: 100
        }
      }
    ]
  },
  {
    name: "Ethnicity",
    scores: [
      {
        label: "White",
        values: {
          score: 100,
          industry: 100,
          global: 100
        }
      },
      {
        label: "Mixed / Multiple ethnic groups",
        values: {
          score: 100,
          industry: 100,
          global: 100
        }
      },
      {
        label: "Asian",
        values: {
          score: 100,
          industry: 100,
          global: 100
        }
      },
      {
        label: "Black / African / Caribbean",
        values: {
          score: 100,
          industry: 100,
          global: 100
        }
      },
      {
        label: "Arab",
        values: {
          score: 100,
          industry: 100,
          global: 100
        }
      },
      {
        label: "Other ethnic group",
        values: {
          score: 100,
          industry: 100,
          global: 100
        }
      },
      {
        label: "Prefer not to say",
        values: {
          score: 100,
          industry: 100,
          global: 100
        }
      }
    ]
  },
  {
    name: "Disability",
    scores: [
      {
        label: "Yes",
        values: {
          score: 100,
          industry: 100,
          global: 100
        }
      },
      {
        label: "No",
        values: {
          score: 100,
          industry: 100,
          global: 100
        }
      },
      {
        label: "Prefer not to say",
        values: {
          score: 100,
          industry: 100,
          global: 100
        }
      }
    ]
  },
  {
    name: "Sexual Orientation",
    scores: [
      {
        label: "Heterosexual / Straight",
        values: {
          score: 100,
          industry: 100,
          global: 100
        }
      },
      {
        label: "Prefer not to say",
        values: {
          score: 100,
          industry: 100,
          global: 100
        }
      },
      {
        label: "LGBTQ+",
        values: {
          score: 100,
          industry: 100,
          global: 100
        }
      },
      {
        label: "Other",
        values: {
          score: 100,
          industry: 100,
          global: 100
        }
      }
    ]
  }
]
